<template>
  <v-row>
    <v-col md="12">
      <v-row>
        <v-col md="3">
          <ModuleHeader>Detalle línea de crédito</ModuleHeader>
          <v-card elevation="0">
            <v-list subheader three-line>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-n4"
                    >Cliente</v-list-item-subtitle
                  >
                  <v-list-item-title>
                    <h4>{{ cliente.Nombres }}
                    {{ cliente.Apellidos }}</h4></v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="mt-n6">
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-n4"
                    >Número de crédito</v-list-item-subtitle
                  >
                  <v-list-item-title><h4>{{ dataLinea.ncdt }}</h4></v-list-item-title>
                  
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="mt-n6">
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-n4"
                    >Limite de crédito</v-list-item-subtitle
                  >
                  <v-list-item-title :v-if="dataLinea.lcdt">
                    ${{ $pgsHelper.formatNumber(dataLinea.lcdt) }}
                  </v-list-item-title>
                  
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="mt-n6">
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-n4"
                    >Día de pago</v-list-item-subtitle
                  >
                  <v-list-item-title>{{ dataLinea.dpgo }}</v-list-item-title>
                  
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="mt-n6">
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-b4"
                    >Tasa de interés anual</v-list-item-subtitle
                  >
                  <v-list-item-title>{{ dataLinea.tia }}%</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="mt-n6">
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-n4"
                    >Tipo de crédito</v-list-item-subtitle
                  >
                  <v-list-item-title>{{
                    tipo.nam
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col md="9">
          <ModuleHeader>Estado de cuenta</ModuleHeader>
          <v-card elevation="0">
            <v-card-text>
              <v-row>
                <v-col md="4" class="text-center">
                  <div class="text-h4">${{ $pgsHelper.formatNumber(5000) }}</div>
                  Pago Periodo
                </v-col>
                <v-col md="4" class="text-center">
                  <div class="text-h4">${{ $pgsHelper.formatNumber(5000) }}</div>
                  Saldo Actual
                </v-col>
                <v-col md="4" class="text-center">
                  <div class="text-h4">${{ $pgsHelper.formatNumber(5000) }}</div>
                  Crédito Disponible
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-tabs v-model="tab" class="mt-4">
            <v-tabs-slider color="blue"></v-tabs-slider>
            <v-tab> Movimientos </v-tab>
            <v-tab v-if="tipo.coi == 'FIN'"> Plan de pagos </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <MovimientosLineasCredito :idLinea="this.$route.params.idLineaCredito" />
            </v-tab-item>
            <v-tab-item>
              <TablaPlanPagos
                v-if="tipo.coi == 'FIN'"
                :FinancialMode="true"
                :periodos="dataLinea.npgo"
                :montoInicial="dataLinea.lcdt"
                :tia="dataLinea.tia"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>



<script>
import Cliente from "../../clases/Cliente.js";
import { mapGetters } from "vuex";
import TablaPlanPagos from "../MainComponents/Membresias/TablaPlanPagos.vue";
import MovimientosLineasCredito from "../MainComponents/LineasCredito/MovimientosLineasCredito.vue"
export default {
  name: "CreditoDetail",
  components: { MovimientosLineasCredito,TablaPlanPagos },
  props: [],
  data() {
    return {
      tab: null,
      periodos: [
        { value: "Actual", text: "Periodo Actual" },
        { value: "Anterior", text: "Periodo Anterior" },
      ],
      dataLinea: {},
    };
  },
  computed: {
    ...mapGetters("LineasCredito",["getTiposCredito"]),
    cliente() {
      let rowclientes = Cliente.getClientsList();
      let dataCliente = this.$pgsHelper.getById(
        rowclientes,
        "Id",
        this.dataLinea.clnt
      );
      return dataCliente;
    },
    tipo(){
      let tipo = this.$pgsHelper.getById(this.getTiposCredito,'id',this.dataLinea.tip)
      return tipo
    }
  },
  methods: {},
  async mounted() {
    this.$store.dispatch("LineasCredito/getTiposCredito");
    const firestore = this.$store.getters.getFirebaseApp.firestore;
    const doc = firestore.doc(
      "BNK_LineasCredito",
      this.$route.params.idLineaCredito
    );
    const data = await firestore.getDoc(doc);
    this.dataLinea = data.data();
  },
};
</script>
